import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function DeliveryChangeList(props) {
  const Config = {
    purchase: {
      apiPath: '/acnotify/getPageList',
      enumMainKey: '',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/delivery-change/detail',
      searchBarPlaceholder: '交料通知单号',
      tabs: ['全部', '草稿', '待确认', '差异待确认', '已退回'],
      countApi: '/acnotify/getNotifyCount',
      arrEnumField: [
        { mainKey: 'B02_Acn_Status', subKey: 'status', value: 'statusName' },
        {
          mainKey: 'B02_CPo_Delivery_Status',
          subKey: 'deliveryStatus',
          value: 'deliveryStatusName'
        }
      ],
      countTransform: (data, self) => {
        let { 0: a, 1: b, 6: c, 2: d } = data;
        setCount([undefined, a, b, c, d]);
      },
      tabConfig: [
        undefined, //全部
        [0], // 草稿
        [1], //待确认
        [6], //差异待确认
        [2] //已退回
      ]
    },
    sale: {
      apiPath: '/cAcnotify/getPageList',
      enumMainKey: '',
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/delivery-change/detail',
      searchBarPlaceholder: '交料通知单号',
      tabs: [
        '全部',
        '待确认',
        '差异待确认',
        '退回待答交',
        '已退回',
        '已确认',
        '已作废'
      ],
      countApi: '/cAcnotify/getNotifyCount',
      arrEnumField: [
        { mainKey: 'B02_Acn_Status', subKey: 'status', value: 'statusName' },
        {
          mainKey: 'B02_CPo_Delivery_Status',
          subKey: 'deliveryStatus',
          value: 'deliveryStatusName'
        }
      ],
      countTransform: (data, self) => {
        let { 1: a, 2: b, 3: c, 4: d, 6: e, 7: f, 8: g } = data;
        let h = (a || 0) + (g || 0);
        setCount([undefined, h, e, f, b, c, d]);
      },
      tabConfig: [
        undefined, //全部
        [1, 8], // 待确认
        [6], // 差异待确认
        [7], // 退回待答交
        [2], // 已退回
        [3], // 已确认
        [4] // 已作废
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  self.beforeSearch = async function () {
    self.searchQueries = {
      status: config.tabConfig[currentTab],
      orderStatus: undefined
    };
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
              {/* {searchKey && (
                <div className="searchKeyBox">
                  查询信息：
                  <div onClick={handleClear}>
                    <span className="singleOmission">{searchKey}</span>
                    <ClearIcon
                      className="verticalMiddle"
                      color="primary"
                      fontSize="inherit"
                    />
                  </div>
                </div>
              )} */}
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.acnXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.acnInnerNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('acn', item.status)
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.customerName}({item.innerCustomerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label>发布时间</label>
                          <div>
                            {formatDate(item.publishTime, 'YYYY-MM-DD')}
                          </div>
                        </li>
                        <li>
                          <label>发布人</label>
                          <div>{item.publishName}</div>
                        </li>
                        <li>
                          <label>送货状态</label>
                          <div>
                            <span
                              className={
                                'u-sign ' +
                                CommonFns.getStatusClass(
                                  'dcs',
                                  item.deliveryStatus
                                )
                              }
                            >
                              {item.deliveryStatusName}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

DeliveryChangeList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(DeliveryChangeList);
